import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'context/auth';
import { useUser } from 'context/user';

function LogoutHandler(): JSX.Element {
  const { logout: authLogout } = useAuth();
  const { logout: userLogout } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      try {
        // Call auth context logout (Firebase signOut)
        await authLogout();

        // Call user context logout (clear user data)
        userLogout();

        // Navigate to sign-in page
        navigate('/sign-in', { replace: true });
      } catch (error) {
        console.error('Error during logout:', error);
        // Even if there's an error, try to redirect to sign-in
        navigate('/sign-in', { replace: true });
      }
    };

    performLogout();
  }, [authLogout, userLogout, navigate]);

  // Return empty fragment while logout is processing
  return <></>;
}

export default LogoutHandler;
